// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"876":"d9d470dd","987":"d9d470dd","2136":"97229b92","5765":"8caf20b7","9122":"d9d470dd"}[chunkId] + ".chunk.css";
};